<div class="meeting-action-btns">
  <ninety-button
    class="tangent-btn meeting-action-btn full-width"
    secondary
    stroked
    ariaLabel="Tangent"
    [disabled]="disabled()"
    (click)="tangentClicked.emit()">
    <terra-icon size="16" icon="warning-triangle" class="tool-icon" />
    Tangent
  </ninety-button>
  <ninety-meeting-sidenav-tools-menu
    [tools]="tools()"
    [meetingId]="meetingId()"
    [disabled]="disabled()"
    (toolSelected)="toolSelected.emit($event)" />
  <ninety-button
    class="notes-btn meeting-action-btn full-width"
    secondary
    stroked
    [disabled]="disabled()"
    (click)="notesToggled.emit()">
    <terra-icon size="16" icon="comment" />
    <span>{{ showNotes() ? 'Hide notes' : 'Show notes' }}</span>
  </ninety-button>
</div>
@if (isPresenter()) {
  <div class="finish-section">
    <terra-divider />
    <ninety-button filled primary class="save-btn full-width" [disabled]="!canFinish()" (click)="finishClicked.emit()">
      <terra-icon size="16" icon="sign-out" />
      <span>Finish</span>
      @if (dayLabel()) {
        <span>{{ dayLabel() }}</span>
      }
    </ninety-button>
  </div>
}
